/** Auto-generated from scripts/build-practice-areas-vi.mjs — do not edit by hand */
export const PRACTICE_AREAS_VI = {
  "corporate": {
    "eyebrow": "Được xếp hạng bởi Chambers - Legal500 - Việt Nam",
    "titleFirst": "Doanh nghiệp, Mua bán &",
    "titleEm": "Sáp nhập",
    "sub": "Tư vấn toàn diện về thành lập doanh nghiệp, mua bán và sáp nhập, liên doanh và cấu trúc đầu tư nước ngoài vào Việt Nam. Được Chambers Asia-Pacific và Legal 500 xếp hạng là công ty luật Việt Nam hàng đầu trong lĩnh vực mua bán & sáp nhập doanh nghiệp.",
    "tags": [
      "Thành lập doanh nghiệp",
      "FDI & Cấp phép",
      "Mua bán & Sáp nhập",
      "Thẩm định pháp lý",
      "Liên doanh",
      "Đầu tư tư nhân"
    ],
    "services": [
      {
        "name": "Thành lập & Giấy phép",
        "desc": "Hỗ trợ nhà đầu tư nước ngoài thành lập hiện diện tại Việt Nam — văn phòng đại diện, công ty 100% vốn nước ngoài, liên doanh và hợp đồng hợp tác kinh doanh — bao gồm giấy chứng nhận đăng ký đầu tư và giấy chứng nhận đăng ký doanh nghiệp."
      },
      {
        "name": "Quản trị doanh nghiệp",
        "desc": "Tư vấn về cấu trúc doanh nghiệp, mô hình quản trị, điều lệ công ty, nghị quyết, quyết định của ban lãnh đạo và tuân thủ pháp luật. Chúng tôi hỗ trợ ban lãnh đạo và đội ngũ quản lý trong công tác quản trị nội bộ và các nghĩa vụ thư ký doanh nghiệp thường xuyên."
      },
      {
        "name": "Tư vấn mua bán & sáp nhập",
        "desc": "Đảm nhận vai trò cố vấn pháp lý chính cho bên mua và bên bán trong các giao dịch M&A trong nước và xuyên biên giới — từ cấu trúc ban đầu đến khi ký kết và hoàn tất giao dịch. Chúng tôi soạn thảo và đàm phán toàn bộ tài liệu giao dịch bao gồm hợp đồng mua bán cổ phẩn (SPA) và hợp đồng chuyển nhượng hoạt động kinh doanh (BTA)."
      },
      {
        "name": "Thẩm định pháp lý",
        "desc": "Thực hiện thẩm định pháp lý toàn diện đối với công ty mục tiêu tại Việt Nam — bao gồm các vấn đề doanh nghiệp, tuân thủ, lao động, bất động sản và thuế. Chúng tôi cung cấp báo cáo rõ ràng, đánh giá rủi ro theo mức độ nhằm hỗ trợ quá trình ra quyết định giao dịch."
      },
      {
        "name": "Liên doanh",
        "desc": "Tư vấn cấu trúc và soạn thảo hợp đồng liên doanh giữa nhà đầu tư nước ngoài và đối tác Việt Nam, bao gồm cơ chế quản trị, xử lý bế tắc, điều khoản thoái vốn và tuân thủ thường xuyên theo Luật Đầu tư của Việt Nam."
      },
      {
        "name": "Đầu tư vốn tư nhân & Quỹ đầu tư",
        "desc": "Tư vấn cho nhà đầu tư tư nhân, quỹ đầu tư mạo hiểm và tổ chức tài chính về đầu tư vào doanh nghiệp Việt Nam — từ cấu trúc giao dịch, thẩm định pháp lý đến hoàn tất giao dịch và quản trị sau đầu tư."
      }
    ],
    "engagements": [
      {
        "num": "01",
        "tag": "Nippon Steel / BlueScope Steel — Liên doanh 1,36 tỷ USD",
        "text": "Thực hiện thẩm định toàn diện và tư vấn về các vấn đề pháp lý tại Việt Nam cho thương vụ Nippon Steel mua lại hoạt động kinh doanh của BlueScope Steel, trong khuôn khổ liên doanh trị giá 1,36 tỷ USD. Đây là một trong những khoản đầu tư sản xuất nước ngoài lớn nhất vào Việt Nam tại thời điểm đó."
      },
      {
        "num": "02",
        "tag": "Merck / ScheringPlough — Sáp nhập toàn cầu 41,1 tỷ USD",
        "text": "Đại diện cho Merck về các vấn đề pháp lý tại Việt Nam trong thương vụ sáp nhập toàn cầu Merck/ScheringPlough trị giá 41,1 tỷ USD — phối hợp với đội ngũ giao dịch toàn cầu và thực hiện toàn bộ thủ tục chấp thuận, đăng ký pháp lý tại Việt Nam."
      },
      {
        "num": "03",
        "tag": "Tập đoàn Tencent/VNG",
        "text": "Đại diện cho Tencent trong giao dịch mua lại cổ phần thiểu số tại VNG Corporation — một trong những thương vụ đầu tư xuyên biên giới đầu tiên quy mô lớn trong lĩnh vực công nghệ tại Việt Nam."
      },
      {
        "num": "04",
        "tag": "JA Solar — Nhà máy mới trên 240 triệu USD",
        "text": "Tư vấn thành lập công ty con tại Việt Nam cho JA Solar để thực hiện hoạt động sản xuất tại tỉnh Bắc Giang. Tổng vốn đầu tư trên 5.000 tỷ đồng (~240 triệu USD) cần được Thủ tướng Chính phủ phê duyệt."
      },
      {
        "num": "05",
        "tag": "Union Underwear (Fruit of the Loom) — Nhà máy tại Thanh Hóa",
        "text": "Tư vấn thành lập công ty con tại Việt Nam cho Union Underwear để thực hiện hoạt động sản xuất tại tỉnh Thanh Hóa, bao gồm tư vấn về việc nhận chuyển nhượng quyền sử dụng đất nhà máy và các hợp đồng xây dựng."
      },
      {
        "num": "06",
        "tag": "Rocket Internet — Các pháp nhân Lazada & Zalora tại Việt Nam",
        "text": "Thành lập các pháp nhân vận hành tại Việt Nam cho hoạt động kinh doanh Lazada và Zalora của Rocket Internet — hai trong số những doanh nghiệp thương mại điện tử giai đoạn đầu nổi bật nhất tại Đông Nam Á."
      }
    ],
    "why": [
      {
        "num": "01",
        "title": "Được xếp hạng liên tục",
        "desc": "Được Chambers Asia-Pacific xếp hạng trong lĩnh vực Doanh nghiệp và Mua bán - Sáp nhập hàng năm kể từ năm 2022, và được Legal 500 xếp hạng hàng năm kể từ năm 2020 — khẳng định năng lực tư vấn ổn định và chất lượng cao trong lĩnh vực Doanh nghiệp và Mua bán - Sáp nhập."
      },
      {
        "num": "02",
        "title": "Kinh nghiệm giao dịch",
        "desc": "Các Luật sư thành viên của chúng tôi đã chủ trì các giao dịch có tổng giá trị lên đến hàng chục tỷ USD — từ các liên doanh tỷ đô và thương vụ sáp nhập toàn cầu đến thành lập nhà máy mới cần phê duyệt của Thủ tướng Chính phủ."
      },
      {
        "num": "03",
        "title": "Chất Lượng Chuyên Biệt, Tiêu Chuẩn Quốc Tế",
        "desc": "Cả hai Luật sư thành viên đều có nhiều năm kinh nghiệm tại các công ty luật quốc tế, mang đến tiêu chuẩn chuyên môn và chất lượng dịch vụ của một hãng luật hàng đầu, kết hợp với khả năng phản hồi nhanh chóng, dịch vụ cá nhân hóa và mức phí cạnh tranh của một công ty luật tinh gọn chuyên biệt."
      }
    ],
    "industries": [
      "Sản xuất & Công nghiệp",
      "May mặc & Giày dép",
      "Dược phẩm",
      "Hàng tiêu dùng nhanh (FMCG)",
      "Bảo hiểm & Dịch vụ tài chính",
      "Công nghệ & Thương mại điện tử",
      "Logistics & Chuỗi cung ứng",
      "Năng lượng tái tạo",
      "Ô tô"
    ],
    "team": [
      {
        "slug": "diep",
        "name": "Dee (Diep) Hoang",
        "title": "Luật sư sáng lập & Luật sư thành viên"
      },
      {
        "slug": "michael",
        "name": "Michael Lee",
        "title": "Luật sư thành viên"
      },
      {
        "slug": "helen",
        "name": "Helen (Trang) Nguyen",
        "title": "Luật sư thành viên"
      }
    ],
    "related": [
      {
        "slug": "licensing",
        "name": "Giấy phép và Tuân thủ",
        "desc": "Xin chấp thuận của cơ quan nhà nước, cấp phép chuyên ngành và tuân thủ pháp luật thường xuyên."
      },
      {
        "slug": "realestate",
        "name": "Bất động sản",
        "desc": "Quyền sử dụng đất, mua lại đất khu công nghiệp và giao dịch bất động sản."
      },
      {
        "slug": "labour",
        "name": "Lao động & Việc làm",
        "desc": "Cơ cấu lao động cho doanh nghiệp mới gia nhập thị trường và sau mua bán & sáp nhập."
      }
    ],
    "cta": {
      "titlePre": "Trao đổi về vấn đề doanh nghiệp",
      "titleEm": "hoặc M&A của bạn",
      "sub": "Các Luật sư thành viên của chúng tôi sẵn sàng tham gia các buổi trao đổi bảo mật về giao dịch hoặc kế hoạch đầu tư của bạn tại Việt Nam.",
      "btns": [
        {
          "cls": "btn-gold2",
          "page": "contact",
          "text": "Liên hệ đội ngũ của chúng tôi"
        },
        {
          "cls": "btn-outline",
          "page": "team",
          "text": "Liên hệ Luật sư thành viên"
        }
      ]
    }
  },
  "licensing": {
    "eyebrow": "Tư vấn · Làm việc với cơ quan nhà nước · Việt Nam",
    "titleFirst": "Giấy phép và",
    "titleEm": "Tuân thủ",
    "sub": "Chúng tôi đóng vai trò là cố vấn pháp lý đáng tin cậy cho khách hàng, hỗ trợ xử lý các vấn đề trong môi trường pháp luật ngày càng phức tạp tại Việt Nam — từ giấy phép chuyên ngành, pháp luật cạnh tranh, quản lý dược phẩm đến các cuộc thanh tra, điều tra của cơ quan nhà nước.",
    "tags": [
      "Cạnh tranh & Chống độc quyền",
      "Điều tra của cơ quan nhà nước",
      "Giấy phép chuyên ngành",
      "Quản lý dược phẩm",
      "Chương trình tuân thủ",
      "Quản lý khủng hoảng"
    ],
    "services": [
      {
        "name": "Giấy phép theo quy định",
        "desc": "Xin giấy phép và phê duyệt theo ngành cụ thể cho các doanh nghiệp có vốn đầu tư nước ngoài hoạt động trong các ngành được quản lý, bao gồm dược phẩm, bảo hiểm, ngân hàng, viễn thông, thương mại điện tử và phân phối ô tô."
      },
      {
        "name": "Cạnh tranh & Chống độc quyền",
        "desc": "Tư vấn về khuôn khổ luật cạnh tranh của Việt Nam, bao gồm hồ sơ kiểm soát sáp nhập, đánh giá hành vi phản cạnh tranh, điều tra các nhóm và đại diện trước Ủy ban Cạnh tranh Việt Nam (VCC)."
      },
      {
        "name": "Điều tra của cơ quan nhà nước",
        "desc": "Đại diện cho khách hàng trong các cuộc điều tra của chính phủ và các thủ tục pháp lý về thuế, hải quan, môi trường, lao động và các cơ quan quản lý theo ngành cụ thể - cung cấp lời khuyên quản lý khủng hoảng chiến lược và quản lý quan hệ với chính phủ."
      },
      {
        "name": "Quản lý dược phẩm",
        "desc": "Tư vấn về cấp phép dược phẩm, đăng ký thuốc, phê duyệt thử nghiệm lâm sàng, giấy phép nhập khẩu và sắp xếp phân phối - dựa trên kinh nghiệm sâu sắc trong môi trường pháp lý chăm sóc sức khỏe của Việt Nam."
      },
      {
        "name": "Chương trình tuân thủ",
        "desc": "Thiết kế và triển khai các chương trình tuân thủ cho các khách hàng đa quốc gia hoạt động tại Việt Nam, bao gồm chống hối lộ và chống tham nhũng, luật cạnh tranh, quyền riêng tư dữ liệu và các nghĩa vụ pháp lý cụ thể của ngành."
      },
      {
        "name": "Thẩm định pháp chế",
        "desc": "Tiến hành thẩm định quy định có mục tiêu đối với các giao dịch M&A, xác định các thiếu sót về giấy phép, các cuộc điều tra đang chờ xử lý và rủi ro pháp lý — đồng thời tư vấn về các chiến lược khắc phục như một phần của cơ cấu giao dịch."
      }
    ],
    "engagements": [
      {
        "num": "01",
        "tag": "Đại lý Ferrari — Phê duyệt nhiều giấy phép",
        "text": "Được chấp thuận đầu tư nước ngoài và thành lập công ty con của một công ty đa quốc gia Hàn Quốc để vận hành đại lý Ferrari tại Việt Nam. Nhận được giấy phép nhập khẩu ô tô cũng như giấy phép bảo hành và bảo trì - một quy trình phê duyệt phức tạp của nhiều cơ quan."
      },
      {
        "num": "02",
        "tag": "Merck Sharp & Dohme — Công ty con Dược phẩm",
        "text": "Thành lập một công ty con tại Việt Nam cho Merck Sharp & Dohme để tham gia nhập khẩu dược phẩm - giải quyết các yêu cầu cấp phép dược phẩm phức tạp của Việt Nam đối với các công ty dược phẩm đa quốc gia."
      },
      {
        "num": "03",
        "tag": "Đào tạo chống tham nhũng — Khách hàng MNC hàng đầu",
        "text": "Tiến hành đào tạo về tuân thủ và chống tham nhũng cho nhiều công ty đa quốc gia hàng đầu đang hoạt động tại Việt Nam, bao gồm các bài thuyết trình về các quy định của Bộ luật Hình sự Việt Nam và các rủi ro tuân thủ theo ngành cụ thể."
      },
      {
        "num": "04",
        "tag": "Điều tra quy định môi trường",
        "text": "Tư vấn cho một công ty đa quốc gia của Đài Loan trong một trong những hoạt động thực thi pháp luật môi trường quan trọng nhất của Việt Nam, đồng thời quản lý hồ sơ pháp lý, liên lạc với chính phủ và thông tin liên lạc về khủng hoảng giữa nhiều cơ quan quản lý của Việt Nam."
      },
      {
        "num": "05",
        "tag": "Kiểm Toán Thuế 10 Năm — MNC Sản Xuất",
        "text": "Tư vấn cho một nhà sản xuất đa quốc gia của Đài Loan về một cuộc kiểm toán thuế cấp cao bao gồm hồ sơ mười năm. Khách hàng đã tuyển dụng hơn 5.000 công nhân với kim ngạch xuất khẩu hàng năm đạt gần 100 triệu USD. Quản lý quy trình quản lý và đàm phán kết quả với cơ quan thuế."
      }
    ],
    "why": [
      {
        "num": "01",
        "title": "Làm việc với cơ quan nhà nước",
        "desc": "Đội ngũ của chúng tôi duy trì mối quan hệ làm việc chặt chẽ với các cơ quan quản lý của Việt Nam như MPI, MOH, MOFA, MOF và các cơ quan quản lý ngành — cho phép chúng tôi thực hiện phê duyệt một cách hiệu quả và quản lý rủi ro pháp lý một cách chủ động."
      },
      {
        "num": "02",
        "title": "Kinh nghiệm xử lý khủng hoảng",
        "desc": "Chúng tôi đã đại diện cho khách hàng trong một số cuộc điều tra pháp lý cấp cao nhất của Việt Nam — bao gồm các hoạt động thực thi pháp luật về môi trường và kiểm toán thuế kéo dài hàng thập kỷ — đưa ra lời khuyên chiến lược dưới áp lực."
      },
      {
        "num": "03",
        "title": "Phạm vi ngành nghề",
        "desc": "Kinh nghiệm quản lý của chúng tôi bao gồm dược phẩm, ô tô, bảo hiểm, thương mại điện tử, hậu cần, sản xuất và dịch vụ tài chính - giúp chúng tôi có chiều sâu trong ngành để tư vấn về những thách thức cấp phép phức tạp nhất."
      }
    ],
    "industries": [
      "Dược phẩm & Chăm sóc sức khỏe",
      "Bảo hiểm & Dịch vụ tài chính",
      "Ô tô",
      "Hàng tiêu dùng nhanh (FMCG)",
      "Thương mại điện tử & Công nghệ",
      "Logistics & Chuỗi cung ứng",
      "Sản xuất",
      "Viễn thông"
    ],
    "team": [
      {
        "slug": "diep",
        "name": "Dee (Diep) Hoang",
        "title": "Luật sư sáng lập & Luật sư thành viên"
      },
      {
        "slug": "michael",
        "name": "Michael Lee",
        "title": "Luật sư thành viên"
      },
      {
        "slug": "helen",
        "name": "Helen (Trang) Nguyen",
        "title": "Luật sư thành viên"
      }
    ],
    "related": [
      {
        "slug": "corporate",
        "name": "Doanh nghiệp, Mua bán & Sáp nhập",
        "desc": "Thành lập, cơ cấu FDI và quản trị doanh nghiệp sau cấp phép."
      },
      {
        "slug": "privacy",
        "name": "Bảo vệ dữ liệu cá nhân",
        "desc": "Tuân thủ Nghị định 13/2023, nộp hồ sơ DPIA và các chương trình bảo vệ dữ liệu cá nhân."
      },
      {
        "slug": "disputes",
        "name": "Giải quyết tranh chấp",
        "desc": "Điều tra của chính phủ, tranh chấp về thuế và bảo vệ thực thi pháp luật."
      }
    ],
    "cta": {
      "titlePre": "Trao đổi về vấn đề tuân thủ",
      "titleEm": "hoặc giấy phép của bạn",
      "sub": "Đội ngũ của chúng tôi tư vấn về các thủ tục xin chấp thuận pháp lý và xử lý các cuộc thanh tra, điều tra của cơ quan nhà nước phức tạp nhất tại Việt Nam.",
      "btns": [
        {
          "cls": "btn-gold2",
          "page": "contact",
          "text": "Liên hệ đội ngũ của chúng tôi"
        },
        {
          "cls": "btn-outline",
          "page": "team",
          "text": "Liên hệ Luật sư thành viên"
        }
      ]
    }
  },
  "labour": {
    "eyebrow": "Được xếp hạng bởi Chambers - Việt Nam",
    "titleFirst": "Lao động &",
    "titleEm": "Việc làm",
    "sub": "Chúng tôi tư vấn cho các công ty Việt Nam cũng như các công ty đa quốc gia về toàn bộ các vấn đề lao động và việc làm — từ cơ cấu lao động và tuân thủ nhân sự đến đàm phán công đoàn, sa thải hàng loạt và tranh chấp liên quan đến các nhân sự cấp cao.",
    "tags": [
      "Hợp đồng lao động",
      "Giấy phép lao động",
      "Nội quy lao động",
      "Quan hệ công đoàn",
      "Sa thải hàng loạt",
      "Tranh chấp nhân sự cấp cao"
    ],
    "services": [
      {
        "name": "Hợp đồng lao động",
        "desc": "Soạn thảo và rà soát hợp đồng lao động cho nhân viên Việt Nam và nước ngoài - bao gồm hợp đồng có thời hạn và không xác định thời hạn, thỏa thuận thử việc và các thỏa thuận điều hành chuyên môn tuân thủ Bộ luật Lao động."
      },
      {
        "name": "Nội quy lao động",
        "desc": "Soạn thảo, cập nhật và đàm phán các quy định lao động nội bộ (nội quy lao động) với công đoàn và Sở LĐTBXH - đảm bảo tuân thủ Bộ luật Lao động đồng thời bảo vệ lợi ích của người sử dụng lao động."
      },
      {
        "name": "Giấy phép lao động & Thị thực",
        "desc": "Quản lý đơn xin cấp giấy phép lao động và thị thực cho nhân viên nước ngoài - bao gồm đơn xin miễn giấy phép lao động, gia hạn và tư vấn về các yêu cầu tài liệu cập nhật theo hướng dẫn của Bộ LĐTBXH."
      },
      {
        "name": "Tranh chấp & Chấm dứt hợp đồng",
        "desc": "Tư vấn cho người sử dụng lao động về các tranh chấp, thủ tục kỷ luật và chấm dứt hợp đồng với nhân viên — giảm thiểu rủi ro kiện tụng và đại diện cho khách hàng trong các khiếu nại chấm dứt hợp đồng sai trái trước tòa án lao động và hội đồng trọng tài Việt Nam."
      },
      {
        "name": "Sa thải hàng loạt",
        "desc": "Tư vấn về các chương trình sa thải hàng loạt phát sinh từ việc tái cơ cấu doanh nghiệp, đóng cửa nhà máy và thu hẹp quy mô - bao gồm việc chuẩn bị kế hoạch sử dụng lao động, tham vấn với công đoàn và quản lý các thông báo của DOLISA."
      },
      {
        "name": "Đào tạo & Rà soát tuân thủ",
        "desc": "Thực hiện các chương trình đào tạo tùy chỉnh về tuân thủ luật lao động, nghĩa vụ chống tham nhũng và chính sách nhân sự - được giảng dạy bằng tiếng Anh hoặc tiếng Việt cho đội ngũ quản lý và bộ phận nhân sự trong tất cả các ngành. Chúng tôi cũng tiến hành kiểm tra việc làm chuyên sâu cho công ty và đề xuất những thay đổi để tuân thủ luật lao động."
      }
    ],
    "engagements": [
      {
        "num": "01",
        "tag": "Danh mục MNC — Tư vấn lao động liên tục",
        "text": "Tư vấn lao động tranh tụng và không tranh tụng cho các tập đoàn đa quốc gia lớn đang hoạt động tại Việt Nam, bao gồm Airbus, Alcon, Daimler, Deutsche Bank, Gap, Ipsen, Johnson & Johnson, Jones & Vining, Levi’s, Marriott, Merck Sharp & Dohme, Microsoft, Werner và Yggdrasil."
      },
      {
        "num": "02",
        "tag": "Chấm dứt hợp đồng nhân sự cấp cao",
        "text": "Tư vấn và đàm phán thỏa thuận chấm dứt hợp đồng cấp cao cho lãnh đạo cấp C tại các tập đoàn đa quốc gia lớn đang hoạt động tại Việt Nam — quản lý đàm phán phức tạp, cấu trúc trợ cấp thôi việc và nghĩa vụ sau khi nghỉ việc."
      },
      {
        "num": "03",
        "tag": "Chương trình sa thải hàng loạt",
        "text": "Đã tư vấn cho nhiều khách hàng đa quốc gia về các chương trình sa thải hàng loạt phát sinh từ tái cơ cấu doanh nghiệp và thay đổi kế hoạch sử dụng lao động - quản lý toàn bộ quy trình từ tham vấn công đoàn thông qua thông báo của DOLISA và giải quyết nhân viên."
      },
      {
        "num": "04",
        "tag": "Nội quy lao động – Đàm phán công đoàn",
        "text": "Đã đàm phán và đăng ký các quy tắc lao động nội bộ với công đoàn và Sở LĐTBXH cho nhiều khách hàng sản xuất lớn - quản lý các cuộc đàm phán phức tạp với đại diện công đoàn và đảm bảo sự chấp thuận theo quy định trong khung thời gian bắt buộc."
      },
      {
        "num": "05",
        "tag": "Đào tạo về tuân thủ và chống tham nhũng",
        "text": "Tổ chức các hội thảo đào tạo về tuân thủ và chống tham nhũng cho các công ty MNC hàng đầu tại Việt Nam - bao gồm các buổi về các điều khoản của Bộ luật Hình sự Việt Nam ảnh hưởng đến nhân viên và quản lý cũng như các phương pháp hay nhất để tuân thủ nhân sự."
      }
    ],
    "why": [
      {
        "num": "01",
        "title": "Kinh nghiệm làm việc sâu sắc với tập đoàn đa quốc gia",
        "desc": "Chúng tôi đã tư vấn cho một số tập đoàn đa quốc gia hàng đầu thế giới về các vấn đề lao động tại Việt Nam - từ Airbus và Daimler đến Microsoft và Johnson & Johnson - mang lại cho chúng tôi kinh nghiệm thực tế chưa từng có trong tất cả các ngành."
      },
      {
        "num": "02",
        "title": "Tranh tụng & Không tranh tụng",
        "desc": "Hoạt động lao động của chúng tôi bao gồm toàn bộ phạm vi - từ việc tuân thủ nhân sự hàng ngày và soạn thảo hợp đồng cho đến các tranh chấp điều hành phức tạp và các thủ tục sa thải hàng loạt trước tòa án và hội đồng trọng tài Việt Nam."
      },
      {
        "num": "03",
        "title": "Am hiểu địa phương, chuẩn mực quốc tế",
        "desc": "Đội ngũ của chúng tôi bao gồm các luật sư địa phương có chuyên môn sâu về Bộ luật Lao động Việt Nam và các luật sư quốc tế hiểu rõ bối cảnh hoạt động của các nhà tuyển dụng đa quốc gia - đưa ra lời khuyên vừa chính xác tại địa phương vừa thực tế về mặt thương mại."
      }
    ],
    "industries": [
      "Sản xuất & Công nghiệp",
      "May mặc & Giày dép",
      "Dược phẩm & Chăm sóc sức khỏe",
      "Hàng tiêu dùng nhanh (FMCG)",
      "Dịch vụ tài chính",
      "Công nghệ & Phần mềm",
      "Logistics",
      "Khách sạn & Dịch vụ",
      "Ô tô"
    ],
    "team": [
      {
        "slug": "diep",
        "name": "Dee (Diep) Hoang",
        "title": "Luật sư sáng lập & Luật sư thành viên"
      },
      {
        "slug": "michael",
        "name": "Michael Lee",
        "title": "Luật sư thành viên"
      },
      {
        "slug": "helen",
        "name": "Helen (Trang) Nguyen",
        "title": "Luật sư thành viên"
      }
    ],
    "related": [
      {
        "slug": "privacy",
        "name": "Bảo vệ dữ liệu cá nhân",
        "desc": "Xử lý dữ liệu nhân viên, nộp hồ sơ DPIA và các chương trình đào tạo bảo vệ dữ liệu cá nhân."
      },
      {
        "slug": "disputes",
        "name": "Giải quyết tranh chấp",
        "desc": "Tranh chấp lao động, bào chữa khi chấm dứt hợp đồng sai trái và tranh chấp về tình trạng dư thừa hàng loạt."
      },
      {
        "slug": "corporate",
        "name": "Doanh nghiệp, Mua bán & Sáp nhập",
        "desc": "Thẩm định việc làm và cơ cấu lực lượng lao động cho các giao dịch M&A."
      }
    ],
    "cta": {
      "titlePre": "Trao đổi về vấn đề lao động",
      "titleEm": "hoặc việc làm của bạn",
      "sub": "Đội ngũ của chúng tôi tư vấn về các tranh chấp lao động và việc làm phức tạp nhất tại Việt Nam trong tất cả các lĩnh vực.",
      "btns": [
        {
          "cls": "btn-gold2",
          "page": "contact",
          "text": "Liên hệ đội ngũ của chúng tôi"
        },
        {
          "cls": "btn-outline",
          "page": "team",
          "text": "Liên hệ Luật sư thành viên"
        }
      ]
    }
  },
  "privacy": {
    "eyebrow": "",
    "titleFirst": "Bảo vệ",
    "titleEm": "dữ liệu cá nhân",
    "sub": "Quy định pháp luật của Việt Nam về bảo vệ dữ liệu cá nhân đã đặt ra các nghĩa vụ tuân thủ mới đáng chú ý cho doanh nghiệp. Chúng tôi hỗ trợ khách hàng đạt được và duy trì sự tuân thủ đầy đủ — từ việc chuẩn bị hồ sơ Đánh giá tác động xử lý dữ liệu cá nhân (DPIA) và nộp hồ sơ cho Bộ Công an đến dịch vụ nhân sự bảo vệ dữ liệu cá nhân (DPO) và đào tạo pháp luật về bảo vệ dữ liệu cá nhân thường xuyên.",
    "tags": [
      "Chuẩn bị & Nộp hồ sơ DPIA",
      "Dịch vụ DPO",
      "Chính sách quyền riêng tư",
      "Hồ sơ OTIA",
      "Đào tạo bảo vệ dữ liệu",
      "Hợp đồng xử lý dữ liệu"
    ],
    "services": [
      {
        "name": "Rà soát tuân thủ",
        "desc": "Chúng tôi tiến hành kiểm tra quyền riêng tư để đánh giá mức độ tuân thủ của công ty với luật bảo vệ dữ liệu cá nhân của Việt Nam, xác định cả những lỗ hổng và cơ hội cải thiện trước sự giám sát của cơ quan quản lý."
      },
      {
        "name": "Nhân sự bảo vệ dữ liệu",
        "desc": "Cung cấp Nhân viên bảo vệ dữ liệu (DPO) bên ngoài, người hướng dẫn chiến lược quyền riêng tư, đảm bảo tuân thủ Luật quyền riêng tư dữ liệu và quản lý hiệu quả các rủi ro về quyền riêng tư dữ liệu một cách liên tục cho tổ chức của bạn."
      },
      {
        "name": "Chuẩn bị & Nộp hồ sơ DPIA",
        "desc": "Soạn thảo hồ sơ Đánh giá tác động xử lý dữ liệu cá nhân (DPIA) và nộp lên Bộ Công an, Cục An ninh mạng và phòng, chống tội phạm sử dụng công nghệ cao — bao gồm toàn bộ biểu mẫu, thông báo và quy định kèm theo."
      },
      {
        "name": "Chuyển dữ liệu cá nhân xuyên biên giới (OTIA)",
        "desc": "Soạn thảo hồ sơ Đánh giá tác động chuyển dữ liệu cá nhân ra nước ngoài (OTIA) cho doanh nghiệp chuyển dữ liệu cá nhân ra ngoài Việt Nam — bao gồm dữ liệu nhân viên và khách hàng — đồng thời quản lý việc nộp hồ sơ và theo dõi với Bộ Công an."
      },
      {
        "name": "Đào tạo bảo vệ dữ liệu",
        "desc": "Cung cấp các khóa đào tạo và nâng cao nhận thức cho tất cả nhân viên về luật bảo mật dữ liệu và các phương pháp hay nhất của Việt Nam - được thực hiện bằng tiếng Anh hoặc tiếng Việt."
      },
      {
        "name": "Tài liệu & Hợp đồng về bảo vệ dữ liệu cá nhân",
        "desc": "Soạn thảo chính sách quyền riêng tư, thỏa thuận xử lý dữ liệu, biểu mẫu đồng ý, thông báo về quyền riêng tư, chính sách cookie và các điều khoản hợp đồng tiêu chuẩn - được điều chỉnh cho phù hợp với hoạt động xử lý dữ liệu cụ thể của bạn và tuân thủ Luật Bảo mật Dữ liệu."
      }
    ],
    "engagements": [
      {
        "num": "01",
        "tag": "Fruit of the Loom Việt Nam — Chương trình tuân thủ đầy đủ",
        "text": "Hỗ trợ Fruit of the Loom Việt Nam điều chỉnh chính sách bảo vệ dữ liệu toàn cầu cho phù hợp pháp luật địa phương, soạn thảo và nộp hồ sơ DPIA cùng hồ sơ Đánh giá tác động chuyển dữ liệu ra nước ngoài (OTIA) lên Bộ Công an, đồng thời đào tạo bảo vệ dữ liệu cho nhân viên trong toàn tổ chức."
      },
      {
        "num": "02",
        "tag": "Henkel —DPIA, OTIA & Đào tạo thường xuyên",
        "text": "Hỗ trợ Henkel, nhà sản xuất vật liệu kết dính công nghiệp hàng đầu của Đức, tổ chức đào tạo nhân viên định kỳ về pháp luật bảo vệ dữ liệu cá nhân của Việt Nam, đồng thời soạn thảo và nộp hồ sơ DPIA và OTIA lên Bộ Công an."
      },
      {
        "num": "03",
        "tag": "Phú Mỹ Hưng — Nộp hồ sơ DPIA",
        "text": "Hỗ trợ Phú Mỹ Hưng, một trong những nhà phát triển bất động sản có vốn đầu tư nước ngoài lớn nhất và hàng đầu Việt Nam, chuẩn bị và nộp hồ sơ DPIA (bao gồm chính sách bảo vệ dữ liệu) lên Bộ Công an."
      },
      {
        "num": "04",
        "tag": "Jones & Vining — Nộp hồ sơ DPIA",
        "text": "Hỗ trợ Jones & Vining, nhà sản xuất khuôn giày và đế lót hàng đầu của Mỹ, chuẩn bị và nộp hồ sơ DPIA bao gồm toàn bộ chính sách bảo vệ dữ liệu cần thiết lên Bộ Công an cho hoạt động tại Việt Nam."
      },
      {
        "num": "05",
        "tag": "Corteva Agriscience Việt Nam — Review & Dịch Tài Liệu",
        "text": "Hỗ trợ Corteva Agriscience Việt Nam trong việc xem xét và dịch các tài liệu bảo vệ dữ liệu bao gồm Đồng ý và thông báo tiếp thị, Biểu mẫu truy cập của khách truy cập, Biểu mẫu tham dự và Thông báo quyền riêng tư của Corteva Agriscience - đảm bảo phù hợp với các yêu cầu bảo vệ dữ liệu của Việt Nam."
      },
      {
        "num": "06",
        "tag": "Quỹ & Trường Lawrence S. Ting — Nộp hồ sơ DPIA",
        "text": "Hỗ trợ Quỹ Lawrence S. Ting (tổ chức phi chính phủ tại Việt Nam) và Trường Lawrence S. Ting (trường phi lợi nhuận thành lập năm 2008) chuẩn bị và nộp hồ sơ DPIA lên Bộ Công an — thể hiện kinh nghiệm tư vấn cho tổ chức phi lợi nhuận và giáo dục."
      }
    ],
    "why": [
      {
        "num": "01",
        "title": "Kinh nghiệm nộp hồ sơ với Bộ Công an",
        "desc": "Chúng tôi đã chuẩn bị và nộp nhiều hồ sơ DPIA và OTIA lên Bộ Công an thay mặt khách hàng đa quốc gia và Việt Nam — mang lại hiểu biết thực tiễn về quy trình nộp hồ sơ, yêu cầu của Bộ Công an và các sai sót thường gặp."
      },
      {
        "num": "02",
        "title": "Chính sách toàn cầu, tuân thủ địa phương",
        "desc": "Chúng tôi chuyên điều chỉnh các chính sách về quyền riêng tư toàn cầu của các công ty đa quốc gia cho phù hợp với yêu cầu pháp lý của Việt Nam — đảm bảo tính nhất quán toàn cầu đồng thời đạt được sự tuân thủ đầy đủ của địa phương với Luật Bảo mật Dữ liệu."
      },
      {
        "num": "03",
        "title": "Đào tạo bằng tiếng Anh & tiếng Việt",
        "desc": "Các chương trình đào tạo về quyền riêng tư dữ liệu của chúng tôi được các đối tác của chúng tôi cung cấp bằng tiếng Anh hoặc tiếng Việt — bao gồm các yêu cầu pháp lý và các biện pháp thực hành tốt nhất theo hình thức phù hợp với cả đội ngũ quản lý quốc tế và nhân viên địa phương."
      }
    ],
    "industries": [
      "Sản xuất & Công nghiệp",
      "Bất động sản & Phát triển",
      "Hàng tiêu dùng nhanh (FMCG)",
      "Dược phẩm & Nông nghiệp",
      "Công nghệ & Fintech",
      "Dịch vụ tài chính",
      "Tổ chức phi chính phủ & Phi lợi nhuận",
      "Giáo dục"
    ],
    "team": [
      {
        "slug": "diep",
        "name": "Dee (Diep) Hoang",
        "title": "Luật sư sáng lập & Luật sư thành viên"
      },
      {
        "slug": "michael",
        "name": "Michael Lee",
        "title": "Luật sư thành viên"
      },
      {
        "slug": "helen",
        "name": "Helen (Trang) Nguyen",
        "title": "Luật sư thành viên"
      }
    ],
    "related": [
      {
        "slug": "labour",
        "name": "Lao động & Việc làm",
        "desc": "Xử lý dữ liệu nhân viên, tuân thủ quyền riêng tư nhân sự và nghĩa vụ dữ liệu giấy phép lao động."
      },
      {
        "slug": "licensing",
        "name": "Giấy phép và Tuân thủ",
        "desc": "Quy định về an ninh mạng và các chương trình tuân thủ quy định rộng hơn."
      },
      {
        "slug": "corporate",
        "name": "Doanh nghiệp, Mua bán & Sáp nhập",
        "desc": "Thẩm định về quyền riêng tư dữ liệu và điều chỉnh tuân thủ sau mua lại."
      }
    ],
    "cta": {
      "titlePre": "Trao đổi về nhu cầu tuân thủ",
      "titleEm": "bảo vệ dữ liệu cá nhân của bạn",
      "sub": "Đội ngũ của chúng tôi đã nộp nhiều hồ sơ Đánh giá tác động xử lý dữ liệu cá nhân và Đánh giá tác động chuyển dữ liệu cá nhân xuyên biên giới lên Bộ Công an thay mặt cho nhiều doanh nghiệp là các công ty đa quốc gia.",
      "btns": [
        {
          "cls": "btn-gold2",
          "page": "contact",
          "text": "Liên hệ đội ngũ của chúng tôi"
        },
        {
          "cls": "btn-outline",
          "page": "toolkits",
          "text": "Xem bộ tài liệu mẫu"
        }
      ]
    }
  },
  "realestate": {
    "eyebrow": "",
    "titleFirst": "Bất động",
    "titleEm": "sản",
    "sub": "Đội ngũ của chúng tôi có kinh nghiệm sâu rộng trong việc tư vấn cho các nhà phát triển, nhà đầu tư, nhà sản xuất và nhà điều hành khách sạn nước ngoài về tất cả các khía cạnh của pháp luật bất động sản và đất đai Việt Nam — từ thẩm định quyền sở hữu và liên doanh đến mua lại đất khu công nghiệp và hợp đồng quản lý khách sạn.",
    "tags": [
      "Quyền sử dụng đất",
      "Hợp đồng liên doanh bất động sản",
      "Mua lại đất khu công nghiệp",
      "Hợp đồng quản lý khách sạn",
      "Thẩm định quyền sở hữu",
      "Hợp đồng xây dựng"
    ],
    "services": [
      {
        "name": "Giao dịch quyền sử dụng đất",
        "desc": "Tư vấn về việc mua lại, chuyển nhượng và cho thuê quyền sử dụng đất (LUR) tại Việt Nam - bao gồm thẩm định quyền sở hữu, đăng ký QSDĐ và tuân thủ Luật Đất đai 2024 cũng như các quy định thi hành."
      },
      {
        "name": "Liên doanh bất động sản",
        "desc": "Cấu trúc và lập hồ sơ liên doanh bất động sản giữa các nhà phát triển nước ngoài và đối tác Việt Nam - bao gồm khung quản trị, thỏa thuận chia sẻ lợi nhuận, cơ chế rút lui và thỏa thuận phát triển dự án."
      },
      {
        "name": "Mua lại đất khu công nghiệp",
        "desc": "Tư vấn cho các công ty sản xuất về việc mua lại đất công nghiệp và cơ sở nhà máy tại các khu công nghiệp Việt Nam - từ việc xác định địa điểm và thẩm định thông qua các hợp đồng chuyển nhượng QSDĐ và xây dựng nhà máy."
      },
      {
        "name": "Hợp đồng quản lý khách sạn",
        "desc": "Tư vấn cho chủ sở hữu và nhà điều hành khách sạn về các thỏa thuận quản lý khách sạn, thỏa thuận nhượng quyền thương mại và thỏa thuận dịch vụ kỹ thuật - với kinh nghiệm đại diện cho cả chủ sở hữu khách sạn Việt Nam và các thương hiệu khách sạn quốc tế."
      },
      {
        "name": "Cho thuê & Bất động sản thương mại",
        "desc": "Soạn thảo và đàm phán các hợp đồng thuê văn phòng, khu bán lẻ và thương mại - bao gồm các hợp đồng cho thuê dài hạn, các thỏa thuận bán và cho thuê lại cũng như đặt hợp đồng cho các dự án phát triển khu dân cư và khu nghỉ dưỡng ngoài kế hoạch."
      },
      {
        "name": "Hợp đồng xây dựng",
        "desc": "Tư vấn về các thỏa thuận xây dựng và phát triển cho các dự án nhà máy, khu dân cư và thương mại - bao gồm lựa chọn nhà thầu, thỏa thuận EPC và cơ chế tránh tranh chấp."
      }
    ],
    "engagements": [
      {
        "num": "01",
        "tag": "VinaCapital — Dự án khu phức hợp trị giá hàng chục tỷ USD",
        "text": "Tư vấn cho VinaCapital về dự án bất động sản hỗn hợp trị giá hàng chục tỷ USD tại miền Trung Việt Nam, bao gồm tư vấn pháp lý, cấu trúc doanh nghiệp, tài liệu giao dịch và tham gia đàm phán với các nhà đầu tư tiềm năng."
      },
      {
        "num": "02",
        "tag": "Kumho E&C — Liên doanh Golf & Residence",
        "text": "Đàm phán và soạn thảo thỏa thuận liên doanh dự án sân golf và khu dân cư tại Quận 9, TP.HCM cho Kumho E&C. Đối tác là Sơn Kim Land - một cuộc đàm phán song phương phức tạp liên quan đến quyền phát triển và đất đai quan trọng."
      },
      {
        "num": "03",
        "tag": "Gaw Capital — Liên doanh Khu phức hợp Quận 2",
        "text": "Tư vấn cho Gaw Capital về một dự án liên doanh bất động sản phức hợp tại Quận 2, Thành phố Hồ Chí Minh - liên quan đến cơ cấu đầu tư xuyên biên giới phức tạp, tài liệu liên doanh và tư vấn quyền sử dụng đất."
      },
      {
        "num": "04",
        "tag": "La Perla Living International — Khu nghỉ dưỡng miền Trung Việt Nam",
        "text": "Tư vấn cho La Perla Living International về một số dự án liên doanh nghỉ dưỡng và lưu trú tại miền Trung Việt Nam, bao gồm Khu nghỉ dưỡng Bãi Tràm — hỗ trợ cơ cấu và đàm phán liên doanh và thu xếp thu hồi đất."
      },
      {
        "num": "05",
        "tag": "Khách sạn Marriott — Land Due Diligence",
        "text": "Tiến hành thẩm định đất đai và tư vấn về các thỏa thuận quản lý khách sạn cho một số khách sạn mang thương hiệu Marriott tại Việt Nam - xem xét giấy chứng nhận quyền sử dụng đất, phê duyệt quy hoạch và giấy phép xây dựng trên nhiều cơ sở kinh doanh."
      },
      {
        "num": "06",
        "tag": "Okura Prestige Sài Gòn — Hợp đồng quản lý khách sạn",
        "text": "Tư vấn cho chủ sở hữu người Việt của Okura Prestige Sài Gòn về hợp đồng quản lý khách sạn với Okura Hotels and Resorts - bao gồm các điều khoản thương mại chính, tiêu chuẩn thực hiện, quyền chấm dứt hợp đồng và các điều khoản bảo vệ chủ sở hữu."
      }
    ],
    "why": [
      {
        "num": "01",
        "title": "Kinh nghiệm với nhà phát triển & nhà đầu tư",
        "desc": "Chúng tôi đã tư vấn cho một số giao dịch bất động sản lớn nhất và nổi bật nhất tại Việt Nam — từ các dự án khu phức hợp trị giá hàng chục tỷ USD đến mua lại đất khu công nghiệp — đại diện cho cả nhà phát triển nước ngoài và chủ đất Việt Nam."
      },
      {
        "num": "02",
        "title": "Chuyên môn về Luật Đất đai 2024",
        "desc": "Sau khi ban hành Luật Đất đai 2024, chúng tôi đã cập nhật phương pháp tư vấn của mình để kết hợp những thay đổi quan trọng ảnh hưởng đến các dự án bất động sản có vốn đầu tư nước ngoài, giấy chứng nhận quyền sử dụng đất và phát triển khu công nghiệp."
      },
      {
        "num": "03",
        "title": "Sản xuất & Khách sạn",
        "desc": "Hoạt động bất động sản của chúng tôi bao gồm cả lĩnh vực công nghiệp và khách sạn - tư vấn cho các nhà sản xuất về việc mua lại đất nhà máy cũng như tư vấn cho chủ sở hữu và nhà điều hành khách sạn về các thỏa thuận quản lý khách sạn với các thương hiệu quốc tế."
      }
    ],
    "industries": [
      "Bất động sản & Phát triển",
      "Khách sạn & Lưu trú",
      "Sản xuất & Công nghiệp",
      "Dịch vụ tài chính & Quỹ",
      "Bán lẻ & Bất động sản thương mại",
      "Khu nghỉ dưỡng & Giải trí",
      "Hạ tầng"
    ],
    "team": [
      {
        "slug": "diep",
        "name": "Dee (Diep) Hoang",
        "title": "Luật sư sáng lập & Luật sư thành viên"
      },
      {
        "slug": "michael",
        "name": "Michael Lee",
        "title": "Luật sư thành viên"
      },
      {
        "slug": "helen",
        "name": "Helen (Trang) Nguyen",
        "title": "Luật sư thành viên"
      }
    ],
    "related": [
      {
        "slug": "corporate",
        "name": "Doanh nghiệp, Mua bán & Sáp nhập",
        "desc": "Cơ cấu M&A bất động sản, mua lại cổ phần của các công ty bất động sản và cơ cấu FDI."
      },
      {
        "slug": "disputes",
        "name": "Giải quyết tranh chấp",
        "desc": "Tranh chấp xây dựng, tranh chấp chủ nhà và người thuê nhà và thực thi pháp luật về bất động sản."
      },
      {
        "slug": "licensing",
        "name": "Giấy phép và Tuân thủ",
        "desc": "Phê duyệt quy hoạch, giấy phép xây dựng và giấy phép môi trường."
      }
    ],
    "cta": {
      "titlePre": "Trao đổi về vấn đề bất động sản",
      "titleEm": "hoặc đất đai của bạn",
      "sub": "Đội ngũ của chúng tôi tư vấn về các giao dịch bất động sản và các vấn đề quyền sử dụng đất phức tạp nhất tại Việt Nam.",
      "btns": [
        {
          "cls": "btn-gold2",
          "page": "contact",
          "text": "Liên hệ đội ngũ của chúng tôi"
        },
        {
          "cls": "btn-outline",
          "page": "team",
          "text": "Liên hệ Luật sư thành viên"
        }
      ]
    }
  },
  "disputes": {
    "eyebrow": "Được xếp hạng bởi Chambers · Trọng tài viên VIAC · Việt Nam",
    "titleFirst": "Giải quyết",
    "titleEm": "tranh chấp",
    "sub": "Dilinh Legal có năng lực vững chắc trong giải quyết tranh chấp. Luật sư Diệp có nhiều năm kinh nghiệm tham gia tranh tụng thương mại tại các cấp tòa án ở Việt Nam, trong khi Michael là trọng tài viên của Trung tâm Trọng tài Quốc tế Việt Nam (VIAC) từ năm 2012. Chúng tôi đại diện cho khách hàng trong các vụ việc tại tòa án Việt Nam, trọng tài thương mại, điều tra pháp lý và các tranh chấp phức tạp về lao động, thuế, môi trường và xây dựng.",
    "tags": [
      "Tranh chấp thương mại",
      "Trọng tài (VIAC)",
      "Tranh chấp lao động",
      "Điều tra của cơ quan nhà nước",
      "Thu hồi nợ",
      "Tranh chấp xây dựng"
    ],
    "services": [
      {
        "name": "Tranh chấp thương mại",
        "desc": "Đại diện cho khách hàng trong các tranh chấp dân sự và thương mại trước tòa án Việt Nam các cấp — bao gồm tranh chấp hợp đồng, thu hồi nợ, tranh chấp cổ đông và thi hành bản án, phán quyết trọng tài."
      },
      {
        "name": "Trọng tài",
        "desc": "Tư vấn và đại diện cho khách hàng trong các vụ trọng tài trong nước và quốc tế, bao gồm trọng tài VIAC. Michael Lee là thành viên hội đồng trọng tài viên VIAC và đã chủ trì các hội đồng trọng tài giá trị cao với số tiền tranh chấp lên đến hàng trăm triệu USD."
      },
      {
        "name": "Tranh chấp lao động & Tố tụng lao động",
        "desc": "Đại diện cho người sử dụng lao động trong các khiếu nại về chấm dứt hợp đồng sai trái, tranh chấp về dư thừa hàng loạt, tranh chấp về việc sa thải người điều hành và các vụ kiện tụng khác liên quan đến việc làm trước tòa án lao động và hội đồng trọng tài Việt Nam."
      },
      {
        "name": "Điều tra từ cơ quan nhà nước & Tranh chấp quản lý hành chính",
        "desc": "Tư vấn cho khách hàng đối mặt với các cuộc điều tra của chính phủ, kiểm toán thuế, tranh chấp hải quan, hành động thực thi pháp luật về môi trường và các thủ tục pháp lý khác — cung cấp lời khuyên về quản lý khủng hoảng chiến lược và đại diện cho khách hàng trước các cơ quan chức năng của Việt Nam."
      },
      {
        "name": "Tranh chấp xây dựng",
        "desc": "Tư vấn về tranh chấp hợp đồng xây dựng, bao gồm các khiếu nại phát sinh từ việc chậm trễ, sai sót, sai sót và không thanh toán — trên cả các dự án xây dựng trong nước và quốc tế tại Việt Nam."
      },
      {
        "name": "Thu hồi nợ",
        "desc": "Đại diện cho các ngân hàng và tập đoàn đa quốc gia trong các vấn đề thu hồi nợ có giá trị cao, bao gồm việc truy tố các vụ kiện dân sự và các thủ tục cưỡng chế đối với các đối tác không trả được nợ."
      }
    ],
    "engagements": [
      {
        "num": "01",
        "tag": "Ô nhiễm môi trường — Vụ việc tiêu biểu",
        "text": "Tư vấn cho một công ty đa quốc gia của Đài Loan về một trong những sự cố ô nhiễm môi trường nghiêm trọng nhất ở Việt Nam. Khách hàng bị buộc tội xả trái phép chất thải công nghiệp độc hại ra biển - một vụ án mang tính bước ngoặt mang tính pháp lý và uy tín lớn."
      },
      {
        "num": "02",
        "tag": "Kiểm toán thuế 10 năm — Xuất khẩu hàng năm 100 triệu USD",
        "text": "Tư vấn cho một nhà sản xuất đa quốc gia của Đài Loan về một cuộc kiểm toán thuế cấp cao bao gồm hồ sơ thuế mười năm. Khách hàng đã tuyển dụng hơn 5.000 công nhân tại hai cơ sở với kim ngạch xuất khẩu hàng năm đạt gần 100 triệu USD."
      },
      {
        "num": "03",
        "tag": "Trọng tài VIAC — Phán quyết trị giá hàng trăm triệu USD",
        "text": "Michael Lee chủ trì hội đồng trọng tài xét xử vụ việc VIAC liên quan đến tranh chấp xây dựng trong dự án khai thác khoáng sản tại Đông Nam Á. Số tiền tranh chấp lên đến hàng trăm triệu USD. Các bên chấp nhận phán quyết mà không kháng cáo — một trong những vụ VIAC giá trị cao thành công nhất trong lịch sử của trung tâm."
      },
      {
        "num": "04",
        "tag": "Tranh chấp xây dựng — Nhà sản xuất hàng may mặc Mỹ",
        "text": "Tư vấn cho một nhà sản xuất hàng may mặc của Mỹ về một tranh chấp xây dựng nghiêm trọng với tổng thầu của họ - liên quan đến rủi ro tài chính đáng kể cũng như các vấn đề hợp đồng và kỹ thuật phức tạp."
      },
      {
        "num": "05",
        "tag": "Tranh chấp lao động cấp độ C & dư thừa hàng loạt",
        "text": "Tư vấn về nhiều tranh chấp lao động cấp cao liên quan đến việc sa thải nhân viên điều hành cấp C và thủ tục sa thải hàng loạt tại các tập đoàn đa quốc gia lớn đang hoạt động tại Việt Nam."
      },
      {
        "num": "06",
        "tag": "Thu hồi nợ — Ngân hàng và Tập đoàn đa quốc gia",
        "text": "Đại diện cho các ngân hàng, tập đoàn đa quốc gia trong các vụ việc thu hồi nợ có giá trị cao, trong đó có việc khởi tố các vụ kiện dân sự trước tòa án Việt Nam."
      }
    ],
    "why": [
      {
        "num": "01",
        "title": "Đội ngũ có trọng tài viên VIAC",
        "desc": "Michael Lee là thành viên Hội đồng trọng tài VIAC từ tháng 5 năm 2012 và từng chủ trì các hội đồng trọng tài quốc tế có giá trị cao. Điều này giúp khách hàng của chúng tôi tiếp cận trực tiếp với kiến ​​thức chuyên môn về trọng tài mà ít công ty nhỏ ở Việt Nam có thể sánh được."
      },
      {
        "num": "02",
        "title": "Kinh nghiệm tố tụng tại Hoa Kỳ",
        "desc": "Michael Lee đã khởi kiện hơn 200 phiên điều trần có bằng chứng và làm luật sư chính xét xử trong 15 phiên tòa xét xử có bồi thẩm đoàn và hội thẩm tại Hoa Kỳ — áp dụng kỷ luật tố tụng nghiêm ngặt, dựa trên bằng chứng cho mọi tranh chấp mà chúng tôi xử lý tại Việt Nam."
      },
      {
        "num": "03",
        "title": "Được xếp hạng về Giải quyết tranh chấp",
        "desc": "Dilinh được cả Chambers Châu Á-Thái Bình Dương và Legal 500 xếp hạng về Giải quyết tranh chấp trong ấn bản năm 2019 - phản ánh hồ sơ theo dõi của chúng tôi về một số tranh chấp và điều tra pháp lý quan trọng nhất ở Việt Nam."
      }
    ],
    "industries": [
      "Sản xuất & Công nghiệp",
      "May mặc & Giày dép",
      "Dịch vụ tài chính & Ngân hàng",
      "Xây dựng & Hạ tầng",
      "Dược phẩm",
      "Ô tô",
      "Logistics & Chuỗi cung ứng",
      "Bất động sản",
      "Khai thác & Tài nguyên",
      "Công nghệ"
    ],
    "team": [
      {
        "slug": "diep",
        "name": "Dee (Diep) Hoang",
        "title": "Luật sư sáng lập & Luật sư thành viên"
      },
      {
        "slug": "michael",
        "name": "Michael Lee",
        "title": "Luật sư thành viên"
      },
      {
        "slug": "helen",
        "name": "Helen (Trang) Nguyen",
        "title": "Luật sư thành viên"
      }
    ],
    "related": [
      {
        "slug": "licensing",
        "name": "Giấy phép và Tuân thủ",
        "desc": "Điều tra của chính phủ, quản lý khủng hoảng và thủ tục pháp lý."
      },
      {
        "slug": "labour",
        "name": "Lao động & Việc làm",
        "desc": "Tranh chấp lao động, yêu cầu chấm dứt hợp đồng trái pháp luật và thủ tục sa thải hàng loạt."
      },
      {
        "slug": "corporate",
        "name": "Doanh nghiệp, Mua bán & Sáp nhập",
        "desc": "Tranh chấp sau mua lại, yêu cầu bảo hành và bất đồng của cổ đông."
      }
    ],
    "cta": {
      "titlePre": "Tự tin giải quyết tranh chấp",
      "titleEm": "",
      "sub": "Đội ngũ giải quyết tranh chấp của chúng tôi đã xử lý các vụ tố tụng, trọng tài và vụ việc pháp lý nổi bật nhất tại Việt Nam.",
      "btns": [
        {
          "cls": "btn-gold2",
          "page": "contact",
          "text": "Liên hệ đội ngũ của chúng tôi"
        },
        {
          "cls": "btn-outline",
          "page": "team",
          "text": "Liên hệ Luật sư thành viên"
        }
      ]
    }
  }
};
